import { render, staticRenderFns } from "./ProfessionalMaterialUpdateDialog.vue?vue&type=template&id=1b75790b&scoped=true&"
import script from "./ProfessionalMaterialUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./ProfessionalMaterialUpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalMaterialUpdateDialog.vue?vue&type=style&index=0&id=1b75790b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b75790b",
  null
  
)

export default component.exports